/**
 * JWT persistence.
 *
 * The token lives in localStorage and is attached by `apiFetch`. Note the
 * consequence for tests: Playwright's `page.request` shares COOKIES, not
 * localStorage, so a spec that logs in through the UI and then calls
 * `page.request.post(...)` is unauthenticated and gets a 401 that reads like a
 * broken endpoint. Fetch a token explicitly via POST /api/auth/login and pass
 * the Authorization header.
 */
const TOKEN_KEY = 'agencias.auth.token';

export function readToken(): string | null {
  try {
    return window.localStorage.getItem(TOKEN_KEY);
  } catch {
    // Private-browsing modes throw rather than returning null.
    return null;
  }
}

export function writeToken(token: string): void {
  try {
    window.localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* non-fatal: the session simply will not survive a reload */
  }
}

export function clearToken(): void {
  try {
    window.localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* non-fatal */
  }
}
